import restClient from "../restClient";

export const getCustomers = async (page = 1, pageSize = 10, { accountFilter } = {}) => {
  try {
    const token = localStorage.getItem('token');
    const params = {
      "pagination[page]": page,
      "pagination[pageSize]": pageSize,
    };
    if (accountFilter && accountFilter !== "all") {
      params.account_filter = accountFilter;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    const response = await restClient.get(`customers`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const searchCustomers = async ({ name = '', ssn = '', accountFilter } = {}) => {
  try {
    const token = localStorage.getItem('token');
    const params = {
      "pagination[page]": 1,
      "pagination[pageSize]": 20,
    };
    if (name) params.search = name;
    if (ssn) params.ssn = ssn;
    if (accountFilter && accountFilter !== "all") {
      params.account_filter = accountFilter;
    }
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params,
    };
    const response = await restClient.get(`customers`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCustomerBulkSelectionMeta = async ({ accountFilter, search, contact }) => {
  try {
    const token = localStorage.getItem('token');
    const params = {};
    if (accountFilter && accountFilter !== "all") params.account_filter = accountFilter;
    if (search) {
      params.search = search;
      params.ssn = search;
    }
    if (contact) params.contact = contact;
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params,
    };
    const response = await restClient.get("customers/bulk-selection-meta", config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCustomerDetail = async (id, tab) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`customers/${id}?type=${tab.toLowerCase().replace(/\s+/g, '-')}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createCustomer = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    // Örnek endpoint, backend'e göre güncellenebilir
    const response = await restClient.post(`customers`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const deleteCustomer = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`customers/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const createBuyer = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    // Örnek endpoint, backend'e göre güncellenebilir
    const response = await restClient.post(`inventory-buyers`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateBuyer = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.put(`inventory-buyers/${id}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateCustomer = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.put(`customers/${id}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const deleteBuyer = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`inventory-buyers/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
